<template>
    <div class="torreairea_torre custom__filters-apartments">
        <!-- <div class="line__vertical-mains"></div> -->
        <button-back  class="custom__filters-torres-back"/>
        <div v-if="loadFilters" class="custom__filters-torres" style="">
            
            <Availables  class="availables-desk availables-torreairea custom__filters-torres-filter" :desarrollo="desarrollo" :type="type"
                :existFilter="existFilter" :filterPrice="rangeFilterPriceTB" :filterPriceDtos="rangeFilterPricesTB"
                @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail" />
        </div>
        <Availables v-if="loadFilters" class="availables-mobile torreairea" :desarrollo="desarrollo" :type="type" :existFilter="existFilter"
            :filterPrice="rangeFilterPriceTB" :filterPriceDtos="rangeFilterPricesTB" @onUpdateModel="updateActiveModel" 
            @defaultDetail="hideDetail"/>
       
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torreairea torrespp-design" :class="{'show-detail':detailPiso}">
                <h1 class="caption__select">
                    <span>{{ img.name }}</span>
                    <span></span>
                </h1>
                <div class="content__depto">
                    <map-highlight-deptos :defaultActive="detailPiso" :indicators="indicators" @activeDetail="showDetailPiso" :torreLevel="levelTorre"
                    :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />

                <div class="content-loader detail-piso"  v-if="loading">
                    <div class="loading__box">
                        <div class="loading show">
                            <div class="spin"></div>
                        </div>
                    </div>
                </div>
                <div  v-show="detailPiso && !loading" class="detail-piso">
                    <Pisos @activeDetailPiso="showDetail" />
                </div>
                 
                <div v-show="!detailPiso && !loading"  class="detail-piso">
                    <h1 class="caption__select ">
                        <span>Seleccione un nivel, clic para ver detalles</span>
                    </h1>
                </div> 
                </div>  
                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel"  :levelId="levelId" :url="url"/>-->
                <div class="line_horizontal" v-if="detailPiso"></div>

            </div>
            <div class="select__box torrea" v-show="detailPiso">
                <div v-show="!detail">
                    <h1 class="caption__select torrea">
                        <span>Seleccione un departamento, clic para ver detalles</span>
                    </h1>
                </div>
                <span style="display: none;">{{ detail ? 'modelo' :'' }}</span>
                
                <div v-show="detail">
                    <Buttons />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlightDeptos from "../../core/rediseno/MapHighlightDeptosAirea";
import ButtonBack from "../../core/ButtonBack";
//import Button from "../../../core/Button.vue";
import Availables from "../../core/rediseno/Availables.vue";
import Pisos from "./Pisos.vue"
import Buttons from "./Model.vue"
import { locationsData } from "../../../utils/torrespaseo/data_map_pisos_torrespaseo"

export default {
    name: "Main",
    components: {
        MapHighlightDeptos,
        //Button,
        ButtonBack,
        Availables,
        Pisos,
        Buttons
    },
    data() {
        return {
            id: this.$route.params.id,
            levelId: 0,
            //this add
            levelTorre: 49,
            //normal
            type: "departamentos",
            desarrollo: "torrespaseodelparque",
            arrFilteredLocations: [],
            nivel: "towerStageLevel",
            url: `cve_torre_etapa=${this.$route.params.id}`,
            micrositeUrl: "https://www.tresmarias.com.mx/senderos/terrenos",
            torres: {
                TORREB: {
                    name: 'TORRE B',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/FachadaPrincipal_recorte.png',
                    width: '630',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '508',
                    transform: '',
                    viewBox: '0 0 630 508'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            rangeFilterPriceTB: [3107790, 3679470],
            rangeFilterPricesTB: {
                'PLANTA BAJA': [3446920, 3184780],
                'PISO 1': [3225400, 3639470, 3107790, 3195450],
                'PISO 2': [3235400, 3205450, 3117790],
                'PISO 3': [3245400, 3187290, 3605410],
                'PISO 4': [3255400, 3197290, 3615410],
                'PISO 5': [3265400, 3147790, 3679470],
                'PISO 6': [3285400, 3157790],
                'PISO 7': [3305400, 3227290],
                'PISO 8': [3655410, 3325400],
                'PISO 9': [3345400, 3187790],
                'PISO 10': [3365400, 3197790],
                'PISO 11': [3385400, 3267290],
                'PISO 12': [3405400, 3277290, 3616360],
            },
            detailPiso:false,
            detail: false,
            indicators: [
                { id: 126, text: 'PB', transform: 'matrix(1 0 0 1 50 502)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "pb-torrespp" },
                { id: 127, text: '1', transform: 'matrix(1 0 0 1 60 470)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 470.62, x2: 165, y2: 470.62, status: true, class: "" },
                { id: 128, text: '2', transform: 'matrix(1 0 0 1 60 435)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 437.62, x2: 165, y2: 437.62, status: true, class: "" },
                { id: 129, text: '3', transform: 'matrix(1 0 0 1 60 400)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 404.62, x2: 165, y2: 404.62, status: true, class: "" },
                { id: 130, text: '4', transform: 'matrix(1 0 0 1 60 370)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 372.62, x2: 165, y2: 372.62, status: true, class: "" },
                { id: 131 , text: '5', transform: 'matrix(1 0 0 1 60 335)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 338.62, x2: 165, y2: 338.62, status: true, class: "" },
                { id: 132, text: '6', transform: 'matrix(1 0 0 1 60 305)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 305.62, x2: 165, y2: 305.62, status: true, class: "" },
                { id: 133, text: '7', transform: 'matrix(1 0 0 1 60 270)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 272.62, x2: 165, y2: 272.62, status: true, class: "" },
                { id: 134, text: '8', transform: 'matrix(1 0 0 1 60 237)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 238.62, x2: 165, y2: 238.62, status: true, class: "" },
                { id: 135, text: '9', transform: 'matrix(1 0 0 1 60 202)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 206.62, x2: 165, y2: 206.62, status: true, class: "" },
                { id: 136, text: '10', transform: 'matrix(1 0 0 1 50 172)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 172.62, x2: 165, y2: 172.62, status: true, class: "" },
                { id: 137, text: '11', transform: 'matrix(1 0 0 1 50 138)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 140.62, x2: 165, y2: 140.62, status: true, class: "" },
                { id: 138, text: '12', transform: 'matrix(1 0 0 1 50 106)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 76, y1: 108.62, x2: 165, y2: 108.62, status: true, class: "" },
            ],
            locations:locationsData,
            //add loading
            loading:false,
            loadFilters:false
        };
    },
    computed: {
        ...mapGetters({
           /*  locations: "getLocations", */
            filterModelos: "getStatusFilterModelos",
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const torre = this.$route.params.torre;
            const torreSeleccionada = this.torres[torre];
            return torreSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
        detailM(){
            return this. detail
        }
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords", "getFilterModelos", "clearDpt"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        showDetailPiso(){
            this.detail = false;
            this.detailPiso = true;
        },
        hideDetailPiso(){
            this.detailPiso= false;
        },
        showDetail() {
            this.detail = true;
        },
        hideDetail(){
            this.detailPiso=false
            this.detail=false;
        },
        loadingFilters(){
            this.loadFilters = true;
        }
    },
    async created() {
        await this.getTowerStageLevels(this.development);
        this.getFilterModelos(this.existFilter)
        this.loadingFilters();
    },
    async beforeDestroy() {
        await this.clearCoords();
        await this.clearDpt();
    },
    mounted() { 
        this.detail=false
    }
};
</script>
<style>
.st1.st2.pb-torrespp {
    font-size: 1.7rem;
}
.maphighlight__box.torrespaseop{
    overflow: hidden;
}
@media(min-width:1201px){
    .custom__filters-torres{
        display:flex; margin: 20px 20px;
    }
    .custom__filters-torres .custom__filters-torres-back{
        width:10% ;
    }
    
    .custom__filters-torres .custom__filters-torres-filter{
        width:90%;
    }
    .custom__filters-apartments .custom__filters-torres-filter{
        width: 100%;
    }
    .maphighlight__box.torreairea.torrespp-design {
        min-height: auto!important;
    }
    
    .maphighlight__box.torreairea.torrespp-design .box__svg{
        /* width: 50%!important; */
        overflow: hidden;
       /*  display: inline-block; */
    }
    .content__depto{
        display: flex;
        align-items: flex-start;
    }
    .maphighlight__box.torreairea.torrespp-design .content__depto div[type="departamentos"]{
        width: 50%!important;
         display: inline-block;
    }
    .detail-piso{
        width: 50%!important;
        display: inline-block;
    }
    .maphighlight__box.torreairea.torrespp-design{
        border: none;
        overflow: hidden;
    }
    .maphighlight__box.torreairea.torrespp-design.show-detail{
        border-right: 1px solid #000;
    }
    .maphighlight__box.torrespaseop .box__svg-deptos{
        width: 90%!important;
    }
    .maphighlight__box.torreairea.torrespp-design{
        overflow-y: scroll;
    }
}
@media(max-width:1200px){
    .maphighlight__box.torreairea.torrespp-design .content__depto div[type="departamentos"]{
        width: 70%;
        margin: auto;
    }
    
}
@media(max-width:1000px){
    .maphighlight__box.torrespaseop .box__svg-deptos{
        width: 80%!important;
    }
}

@media(max-width:600px){
    .maphighlight__box.torreairea.torrespp-design .content__depto div[type="departamentos"]{
        width: 90%;
        margin: auto;
    }
    
}
</style>
